<template>
  <article id="article-miniapp-setting">
    <section class="section-helper-links">
      <ul class="setting-list">
        <li class="setting-row">
          <a
            data-action="privacy_policy"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://www.finnomena.com/privacy-policy?webview=line&bt_id=71')"
            href="javascript:;"
          >
            <div class="left">Privacy Policy</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <a
            data-action="cookie_policy"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://www.finnomena.com/cookies-policy?webview=line&bt_id=71')"
            href="javascript:;"
          >
            <div class="left">Cookies</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <a
            data-action="data_partners"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://www.finnomena.com/data-partners?webview=line&bt_id=71')"
            href="javascript:;"
          >
            <div class="left">Our Partners</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <a
            data-action="terms"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://www.finnomena.com/terms?webview=line&bt_id=71')"
            href="javascript:;"
          >
            <div class="left">Terms & Conditions</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
      </ul>
    </section>
    <section class="section-notice">
      <div class="description">
        ท่านสามารถยกเลิกรับข้อมูลทางการตลาดจาก FINNOMENA ได้ที่เว็บไซต์ FINNOMENA
      </div>
    </section>
  </article>
</template>
<script>
export default {
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  methods: {
    openWindow(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#article-miniapp-setting {
  position: relative;
  .section-helper-links {
    .setting-list {
      padding: 0;
      margin: 0;
      .setting-row {
        pointer-events: none;
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid $color-border !important;
        text-decoration: none;
        padding: 0px 16px;
        @include finRippleBtn($color-white, none, $color-normal-text);
        &:first-child {
          border-top: 1px solid $color-border;
        }
        a {
          display: block;
          text-decoration: none;
          @extend %font-size-s;
          color: $color-normal-text;
          pointer-events: auto;
          cursor: pointer;
          div {
            pointer-events: none;
          }
        }
        .fa-chevron-right {
          color: $color-light-grey-2;
          font-size: 14px;
        }
        .item {
          padding: 16px 0px;
          .left {
            text-align: left;
            @extend %font-size-s;
            color: $color-normal-text;
            @include finCol(11, 12, 0px, middle, true, true);
          }
          .right {
            text-align: right;
            right: 18px;
            @include finCol(1, 12, 0px, middle, false, true);
          }
        }
      }
    }
  }
  .section-notice {
    padding: 32px 24px;
    .description {
      text-align: center;
      @extend %font-size-s;
      color: $color-secondary;
    }
  }
}
</style>